<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="6" md="4" lg="3">
        <date-picker v-model="date" single-date :disabled="loading.load" />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <text-field
          v-model="pretraga"
          kind="search"
          :label="$t('search')"
          hide-details
          :disabled="loading.load"
        />
      </v-col>
      <v-col cols="12">
        <v-row
          v-if="loading.load"
          justify="center"
          align="center"
          style="min-height: 400px"
        >
          <v-col cols="auto">
            <v-progress-circular
              indeterminate
              size="64"
              color="primary"
            ></v-progress-circular>
          </v-col>
        </v-row>
        <div v-else id="table8">
          <template
            v-for="(comapny, companyKey) in search && search.length > 0
              ? desserts4.filter((i) => search.includes(i.company))
              : desserts4"
          >
            <h2 class="text-center mt-5 mb-2">
              {{ comapny.company }} - {{ $t("report") }} {{ $t("taken") }} /
              <span style="color: rgb(251, 109, 59)">{{ $t("ordered") }}</span>
            </h2>
            <v-data-table
              :search="pretraga"
              id="table4"
              :headers="headersM"
              :items="comapny.foods"
              class="ordera-box-shadow striped-table"
              hide-default-footer
              disable-pagination
              :loading="loading.load"
            >
              <template v-slot:item.shift_one="{ item }">
                {{ item.shift_one_payed || 0 }} /
                <span style="color: rgb(251, 109, 59)">{{ item.shift_one || 0 }}</span>
              </template>
              <template v-slot:item.shift_two="{ item }">
                {{ item.shift_two_payed || 0 }} /
                <span style="color: rgb(251, 109, 59)">{{ item.shift_two || 0 }}</span>
              </template>
              <template v-slot:item.shift_three="{ item }">
                {{ item.shift_three_payed || 0 }} /
                <span style="color: rgb(251, 109, 59)">{{ item.shift_three || 0 }}</span>
              </template>
              <template v-slot:item.total="{ item }">
                {{ item.total_payed || 0 }} /
                <span style="color: rgb(251, 109, 59)">{{ item.total || 0 }}</span>
              </template>
            </v-data-table>
          </template>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
import mealService from "@/services/meal";
import reportService from "@/services/report";
import hasSnackbar from "@/mixins/hasSnackbar";
export default {
  mixins: [hasSnackbar],
  data() {
    return {
      name: "Намирнице",
      pretraga: "",
      search: "",
      moment: moment,
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      report: null,
      report2: null,
      reservedItemsData: "",
      selectedMeal: {
        foods: [],
        name: "",
        image: {
          name: "",
        },
      },
      total: [],
      meals: [],
      users: [],
      loading: {
        load: false,
        showMeal: false,
        changeOrderState: false,
        reservedMeals: false,
      },
      headers: [
        { text: this.$t("r_b"), value: "num" },
        { text: this.$t("grocery"), value: "menu" },
        { text: this.$t("1st_shift"), value: "shift_one" },
        { text: this.$t("2nd_shift"), value: "shift_two" },
        { text: this.$t("3rd_shift"), value: "shift_three" },
        { text: this.$t("total"), value: "total" },
      ],
      headersM: [
        { text: this.$t("r_b"), value: "num", sortable: false },
        { text: this.$t("meal"), value: "name" },
        { text: this.$t("1st_shift"), value: "shift_one" },
        { text: this.$t("2nd_shift"), value: "shift_two" },
        { text: this.$t("3rd_shift"), value: "shift_three" },
        { text: this.$t("total"), value: "total" },
      ],
      tab: "",
      items: [
        {
          tab: this.$t("t_o"),
          content: "Tab 8 Content",
          print: "table8",
          icon: "mdi-check-underline-circle",
        },
      ],
    };
  },
  methods: {
    toNumber(value) {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : 0;
    },
    resolveShiftKey(shiftName) {
      const normalized = String(shiftName || "")
        .toLowerCase()
        .trim()
        .replace(/\s+/g, "")
        .replace(/_/g, "-");

      if (
        normalized === "1-smena" ||
        normalized === "1-smjena" ||
        normalized === "shift-one" ||
        normalized === "shiftone" ||
        normalized === "shift1" ||
        normalized === "first-shift" ||
        normalized === "prvasmena" ||
        normalized === "prvasmjena"
      ) {
        return "shift_one";
      }

      if (
        normalized === "2-smena" ||
        normalized === "2-smjena" ||
        normalized === "shift-two" ||
        normalized === "shifttwo" ||
        normalized === "shift2" ||
        normalized === "second-shift" ||
        normalized === "drugasmena" ||
        normalized === "drugasmjena"
      ) {
        return "shift_two";
      }

      if (
        normalized === "3-smena" ||
        normalized === "3-smjena" ||
        normalized === "shift-three" ||
        normalized === "shiftthree" ||
        normalized === "shift3" ||
        normalized === "third-shift" ||
        normalized === "trecasmena" ||
        normalized === "trecasmjena"
      ) {
        return "shift_three";
      }

      return null;
    },
    async reservedMeals() {
      if (this.loading.reservedMeals) {
        console.warn(
          "Reserved meals operation already in progress, skipping duplicate request"
        );
        return;
      }

      this.loading.reservedMeals = true;

      try {
        const data = await reportService.getRestaurantRezervniObroci(
          this.$store.state.restaurant.id,
          {
            company: this.search5.join(),
            date: moment(this.date[0]).format("YYYY-MM-DD"),
            date2: moment(this.date[1]).format("YYYY-MM-DD"),
          }
        );
        this.reservedItemsData = data.data;
      } catch (error) {
        console.error("Error loading reserved meals:", error);
      } finally {
        this.loading.reservedMeals = false;
      }
    },
    async showMeal(id) {
      if (this.loading.showMeal) {
        console.warn(
          "Show meal operation already in progress, skipping duplicate request"
        );
        return;
      }

      this.loading.showMeal = true;

      try {
        const res = await mealService.getMealById(id);
        this.selectedMeal = res.data;
        this.dialog = true;
      } catch (error) {
        console.error("Error loading meal:", error);
        this.showErrorSnackbar(error, this.$t("error_loading_meal"));
      } finally {
        this.loading.showMeal = false;
      }
    },
    print() {},
    async load() {
      if (this.loading.load) {
        console.warn("Load operation already in progress, skipping duplicate request");
        return;
      }

      this.search = "";
      const restaurant =
        this.$store.state.company?.restaurant || this.$store.state.restaurant;

      if (!restaurant) return;

      this.loading.load = true;

      const params = {
        date: moment(this.date).format("YYYY-MM-DD"),
        date2: moment(this.date).format("YYYY-MM-DD"),
      };

      try {
        const res = await reportService.getRestaurantCompanies(restaurant.id, params);
        this.report2 = res.data;
      } catch (error) {
        console.error("Error loading report:", error);
        this.showErrorSnackbar(error, this.$t("error_loading_report"));
      } finally {
        this.loading.load = false;
      }
    },
  },
  created() {
    this.load();
  },
  computed: {
    desserts4() {
      if (!this.report2 || typeof this.report2 !== "object") {
        return [];
      }

      const companies = [];

      for (const companyName in this.report2) {
        const shifts = this.report2[companyName] || {};
        const mealsByName = {};
        let companyId = null;

        for (const shiftName in shifts) {
          const shiftKey = this.resolveShiftKey(shiftName);
          const meals = shifts[shiftName] || {};

          for (const mealName in meals) {
            const mealData = meals[mealName] || {};
            const quantity = this.toNumber(mealData.quantity);
            const quantityPayed = this.toNumber(mealData.quantity_payed);

            if (!mealsByName[mealName]) {
              mealsByName[mealName] = {
                name: mealName,
                id: mealData.id,
                shift_one: 0,
                shift_two: 0,
                shift_three: 0,
                shift_one_payed: 0,
                shift_two_payed: 0,
                shift_three_payed: 0,
                total: 0,
                total_payed: 0,
              };
            }

            if (companyId === null && mealData.company_id !== undefined) {
              companyId = mealData.company_id;
            }

            if (shiftKey) {
              mealsByName[mealName][shiftKey] += quantity;
              mealsByName[mealName][`${shiftKey}_payed`] += quantityPayed;
            }

            mealsByName[mealName].total += quantity;
            mealsByName[mealName].total_payed += quantityPayed;
          }
        }

        const foods = Object.values(mealsByName).map((meal, index) => ({
          num: index + 1,
          ...meal,
        }));

        if (foods.length) {
          foods.push({
            num: "",
            name: "УКУПНО",
            shift_one: foods.reduce(
              (sum, item) => sum + this.toNumber(item.shift_one),
              0
            ),
            shift_two: foods.reduce(
              (sum, item) => sum + this.toNumber(item.shift_two),
              0
            ),
            shift_three: foods.reduce(
              (sum, item) => sum + this.toNumber(item.shift_three),
              0
            ),
            shift_one_payed: foods.reduce(
              (sum, item) => sum + this.toNumber(item.shift_one_payed),
              0
            ),
            shift_two_payed: foods.reduce(
              (sum, item) => sum + this.toNumber(item.shift_two_payed),
              0
            ),
            shift_three_payed: foods.reduce(
              (sum, item) => sum + this.toNumber(item.shift_three_payed),
              0
            ),
            total: foods.reduce((sum, item) => sum + this.toNumber(item.total), 0),
            total_payed: foods.reduce(
              (sum, item) => sum + this.toNumber(item.total_payed),
              0
            ),
          });
        }

        companies.push({
          id: companyId,
          company: companyName,
          foods,
        });
      }

      return companies;
    },
  },
  watch: {
    date() {
      this.load();
    },
  },
};
</script>
